module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.onClick || _vm.url ? 'text-click text-center' : 'text-dash text-center',
    style: (_vm.bgStyle),
    on: {
      "click": _vm.clicked
    }
  }, [_c('el-row', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.isAbove) ? _c('el-col', {
    attrs: {
      "span": 24,
      "align": "center"
    }
  }, [_c('span', {
    style: (_vm.valueStyle)
  }, [_vm._v(_vm._s(_vm.thisValue))])]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24,
      "align": "center"
    }
  }, [(!_vm.isAbove) ? _c('span', {
    style: (_vm.valueStyle)
  }, [_vm._v(_vm._s(_vm.thisValue))]) : _vm._e(), _vm._v("\n           "), (_vm.icon) ? _c('i', {
    class: _vm.icon,
    style: (_vm.iconStyle)
  }) : _vm._e()])], 1), _vm._v(" "), _c('el-row', {
    style: (_vm.captionStyle)
  }, [_c('el-col', {
    attrs: {
      "span": 24,
      "align": "center"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.noPlural ? _vm.caption : _vm.plural(_vm.caption, _vm.thisValue)) + "\n      ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e61487e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/DashText.vue
// module id = 1437
// module chunks = 0